import * as _ from 'underscore';
import { ISiteSettingsForServerAdminFormScope } from '../../settings/controllers/SiteSettingsForServerAdminFormCtrl';
import { SettingsFormService } from '../../settings/directives/tbSettingsCoordinator';
import { ISiteSettingsForServerAdmin } from '../../settings/interfaces/ISite';
import { ISiteAdminSettings } from '../../settings/interfaces/ISiteSettingsForSiteAdmin';
import { FeatureFlags } from '../FeatureFlags';
import { L10n } from '../L10n/L10n';
import { Module } from '../Module';
import { defaultSiteSettingsForServerAdmin, defaultSiteSettingsForSiteAdmin, defaultSubscriptionSettingsForSite, Sites } from '../resources/Sites';
import { IError } from '../ServerApi/types/IError';
import { ConfirmActionDialog } from './ConfirmActionDialog';
import { ModalSize } from './ModalService';
import { ServerService } from './ServerService';
import { ToasterService, ToastType } from './ToasterService';

export class CreateSiteAction {

  public static $inject = [
    'ConfirmActionDialog',
    '$translate',
    '$q',
    'ToasterService',
    'ServerService',
    'SettingsFormService',
    'Sites'
  ];

  constructor(
    private ConfirmActionDialog: ConfirmActionDialog,
    private $translate: ng.translate.ITranslateService,
    private $q: ng.IQService,
    private toaster: ToasterService,
    private server: ServerService,
    private formService: SettingsFormService,
    private Sites: Sites) { }

  public execute(parentScope: ng.IScope): ng.IPromise<any> {
    return this.Sites.getCurrentSiteSettingsForServerAdmin().then((siteSettingsForServerAdmin: ISiteSettingsForServerAdmin) => {
      const dialogScope: ISiteSettingsForServerAdminFormScope = (parentScope.$new(true)) as ISiteSettingsForServerAdminFormScope;

      dialogScope.siteSettings = angular.copy(defaultSiteSettingsForSiteAdmin);
      const copySubscriptionSettings = siteSettingsForServerAdmin.subscriptionSettings;
      if (!_.isUndefined(copySubscriptionSettings)) {
        dialogScope.siteSettings.subscriptionSettings = angular.copy(defaultSubscriptionSettingsForSite);
        dialogScope.siteSettings.subscriptionSettings.serverAllowSubscriptionAttachments =
          copySubscriptionSettings.serverAllowSubscriptionAttachments;
      }

      dialogScope.sharedForm = this.formService;
      dialogScope.sharedForm.clearForms();

      dialogScope.siteSettingsForServerAdmin = angular.copy(defaultSiteSettingsForServerAdmin);
      dialogScope.siteSettingsForServerAdmin.settings.guestAccessEnabled = this.server.isGuestEnabled();
      dialogScope.siteSettingsForServerAdmin.settings.runNowEnabled = FeatureFlags.enableRunNowEnabled ? this.server.isRunNowEnabled() : undefined;
      const siteAdminSettings = dialogScope.siteSettings.siteAdminSettings as ISiteAdminSettings;

      // Set default value for Sandbox based on Server Setting
      siteAdminSettings.siteSandboxSettings.sandboxEnabled = this.server.isSandboxEnabledByDefaultForNewSites();

      // Default to derived permissions enabled if cataloging is enabled on the server.
      if (this.server.catalogingOnServerEnabled()) {
        siteAdminSettings.derivedPermissionsEnabled = true;
      }

      dialogScope.isDefaultSite = false;
      dialogScope.hideNameAndId = false;
      dialogScope.showEncryptionStatus = false; // because there is no encryption status to be shown for new sites
      dialogScope.hideAvailability = true;
      dialogScope.hideRevisionHistoryLimitWarning = true;
      dialogScope.showRemoteAgentsSection = false; // Because there would never be new agents for a new site.
      dialogScope.autoSelectSiteName = true;
      return this.ConfirmActionDialog.open({
        scope: dialogScope as ng.IScope,
        title: this.$translate.instant('newSiteDialogTitle'),
        bodyTemplateUrl: 'siteDialog.html',
        actionName: this.$translate.instant('newSiteDialogSubmit'),
        confirmDisabled: () => _.isEmpty(dialogScope.sharedForm) || !dialogScope.sharedForm.state.isValid(),
        action: () => {
          return this.Sites.createSite(
            dialogScope.siteSettingsForServerAdmin.settings,
            siteAdminSettings,
            dialogScope.siteSettings.subscriptionSettings)
            .then(
            () => {
              this.toaster.pop({
                type: ToastType.Info,
                text: this.$translate.instant('siteCreateSuccess', {
                  SITE_NAME: L10n.elideIfLong(dialogScope.siteSettingsForServerAdmin.settings.name)
                })
              });
              this.server.refreshSessionInfo(); // Refresh top bar
            }, (errors: IError[]) => {
              this.errorMessages(errors, dialogScope.siteSettingsForServerAdmin);
              return this.$q.reject();
            });
        },
        size: ModalSize.fitToContent
      }).result.finally(() => {
        dialogScope.sharedForm.clearForms();
        dialogScope.$destroy();
      });
    });
  }

  private errorMessages(errors: IError[], site: ISiteSettingsForServerAdmin): void {
    _.each(errors, (error: IError) => {
      this.toaster.pop({ type: ToastType.Error, text: this.Sites.errorMessage(error.code, site) });
    });
  }

}

Module.instance().service('CreateSiteAction', CreateSiteAction);
